import { render, staticRenderFns } from "./PartnerRedirectModal.vue?vue&type=template&id=f640ca3c&scoped=true&"
import script from "./PartnerRedirectModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PartnerRedirectModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PartnerRedirectModal.vue?vue&type=style&index=0&id=f640ca3c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f640ca3c",
  null
  
)

export default component.exports